import update from 'immutability-helper';
import Store from '../../../interfaces/Store';
import {
  LIGHTNING_SETUP_CORRECT_NO_CHANGE_NEEDED,
  ValidationAndLightingSetup
} from '../../../interfaces/Validation';

export const validationAndLightingSetupReducer = (
  state: Store,
  { validation, lightingSetup }: ValidationAndLightingSetup
): Store => {
  let articles = state.configuration.articles;
  let requiredLightingArticles = state.configuration.requiredLightingArticles;

  if (lightingSetup !== LIGHTNING_SETUP_CORRECT_NO_CHANGE_NEEDED) {
    requiredLightingArticles = lightingSetup
      .map(setup => setup.requiredLightingArticles)
      .reduce((result, current) => result.concat(current), []);

    const articlesToUpdate = lightingSetup.map(setup => setup.articleId);
    articles = state.configuration.articles.map(article => {
      if (articlesToUpdate.includes(article.id)) {
        const relatedLightingSetup = lightingSetup.find(setup => setup.articleId === article.id);
        const requiredLightingArticles = relatedLightingSetup.requiredLightingArticles.map(
          article => article.id
        );
        return { ...article, requiredLightingArticlesIds: requiredLightingArticles };
      } else {
        return article;
      }
    });
  }

  return update(state, {
    configuration: {
      requiredLightingArticles: {
        $set: requiredLightingArticles
      },
      articles: {
        $set: articles
      }
    },
    validationErrors: {
      $set: validation.unfixableErrors
    }
  });
};
